import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import { Link } from 'react-router-dom';
import logo from '../assets/images/mafratintas.ico';

function Topbar() {
  return (
    <div className="container-fluid bg-primary text-white d-none d-lg-flex wow fadeIn" data-wow-delay="0.1s">
      <div className="container py-3">
        <div className="d-flex align-items-center">
          <Link to="/" className="text-decoration-none d-flex align-items-center">
          <img
            src={logo}
            alt="Logo Mafra Tintas"
            style={{ height: '40px', marginRight: '10px' }}
          />
            <span className="text-white fw-bold m-0">MAFRA TINTAS</span>
          </Link>
          <div className="ms-auto d-flex align-items-center">
            <small className="ms-4"><i className="fa fa-map-marker-alt me-3"></i>Rua Maringá, 2200, Ivaté - PR</small>
            <small className="ms-4"><i className="fa fa-envelope me-3"></i>mafratintas01@gmail.com</small>
            <small className="ms-4"><i className="fa fa-phone-alt me-3"></i>44 9 98827-3599</small>
            <div className="ms-3 d-flex">
              {/* <a className="btn btn-sm-square btn-light text-primary ms-2" href="https://www.instagram.com/tintasmafra/"><i className="fab fa-instagram"></i></a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
